import React, 
      { useState , 
        useEffect,
        useRef , }       from 'react'
import Grid              from '@mui/material/Grid'
import Box               from '@mui/material/Box'
import Typography        from '@mui/material/Typography'
import Paper             from '@mui/material/Paper'
import Radio             from '@mui/material/Radio'
import RadioGroup        from '@mui/material/RadioGroup'
import FormControlLabel  from '@mui/material/FormControlLabel'
import ArrowForwardIcon  from '@mui/icons-material/ArrowForward'
import store             from '../../store'
import '../../App.css'
import '../../style.css'
import {GAKUNEN_ROOT_BOX_SX     ,
        GAKUNEN_SCREEN_PAPER_SX ,
        GAKUNEN_TITLE_TEXT_SX   ,
        GAKUNEN_SELECT_BOX_SX   ,
        GAKUNEN_MESSAGE_GRID_SX ,
        GAKUNEN_MESSAGE_TEXT_SX , } from '../Style/GakunenSelectStyle'

function GakunenSelect({ gakunen, setGakunen }) {
  // ラジオボタンの選択が変更された時の処理
  const handleRadioChange = (event) => {
    const value = event.target.value
    setGakunen(value)                      // 親の state を更新
    store.getState().GakunenSelect = value // 互換用に store にも反映
    console.log("選択中の学年:", value)
  }

  useEffect(() => {
    console.log("選択中の学年=>", gakunen)
  }, [gakunen])

  return (
    <Box sx={GAKUNEN_ROOT_BOX_SX}>
      {/* 画面 */}
      <Paper sx={GAKUNEN_SCREEN_PAPER_SX}>
        <Grid container spacing={0}>
          {/* タイトル表示 */}
          <Grid item xs={12} align="center">
            <Typography sx={GAKUNEN_TITLE_TEXT_SX}>
              がくねんをせんたく
            </Typography>
          </Grid>

          {/* 選択欄表示 */}
          <Grid item xs={12} align="center">
            <Box sx={GAKUNEN_SELECT_BOX_SX}>
              <RadioGroup 
                name="radio-buttons-group"
                value={gakunen} 
                onChange={handleRadioChange}
              >
                <Grid container spacing={0}>
                  <Grid item xs={6}>
                    <FormControlLabel 
                      value="1" 
                      control={
                        <Radio 
                          icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                          checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                        />
                      }
                      label="1ねんせい" 
                      sx={{ marginBottom: '-3px' }}
                      tabIndex={0}
                    />
                    <FormControlLabel 
                      value="2" 
                      control={
                        <Radio 
                          icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                          checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                        />
                      }
                      label="2ねんせい" 
                      sx={{ marginTop: '-3px' }}
                      tabIndex={0}
                    />
                    <FormControlLabel 
                      value="3" 
                      control={
                        <Radio 
                          icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                          checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                        />
                      }
                      label="3ねんせい" 
                      sx={{ marginTop: '-3px' }}
                      tabIndex={0}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControlLabel 
                      value="4" 
                      control={
                        <Radio 
                          icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                          checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                        />
                      }
                      label="4ねんせい" 
                      sx={{ marginTop: '-3px' }}
                      tabIndex={0}
                    />
                    <FormControlLabel 
                      value="5" 
                      control={
                        <Radio 
                          icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                          checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                        />
                      }
                      label="5ねんせい" 
                      sx={{ marginTop: '-3px' }}
                      tabIndex={0}
                    />
                    <FormControlLabel 
                      value="6" 
                      control={
                        <Radio 
                          icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                          checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                        />
                      }
                      label="6ねんせい" 
                      sx={{ marginTop: '-3px' }}
                      tabIndex={0}
                    />
                  </Grid>
                </Grid>
              </RadioGroup>
            </Box>
          </Grid>

          {/* メッセージ欄表示 */}
          <Grid 
            item xs={12} 
            align="center"
            sx={GAKUNEN_MESSAGE_GRID_SX}
          >
            <Typography
              sx={GAKUNEN_MESSAGE_TEXT_SX}
              tabIndex={0}
            >
              がくねんをえらんでね<br />
              1.↑↓でえらぶ<br />
              2.Aボタンでけってい
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Grid container spacing={2}>
        <Grid item xs={12} align="center"></Grid>
      </Grid>
    </Box>
  )
}

export default GakunenSelect
